var map = {
	"./assets/images/0/bg/big/01.jpg": 4167,
	"./assets/images/0/bg/small/01.jpg": 1381,
	"./assets/images/1/bg/big/01.jpg": 7080,
	"./assets/images/1/bg/big/02.jpg": 6773,
	"./assets/images/1/bg/big/03.jpg": 9631,
	"./assets/images/1/bg/big/04.jpg": 8977,
	"./assets/images/1/bg/small/01.jpg": 895,
	"./assets/images/1/bg/small/02.jpg": 333,
	"./assets/images/1/bg/small/03.jpg": 9051,
	"./assets/images/1/bg/small/04.jpg": 1972,
	"./assets/images/11/bg/big/01.jpg": 1941,
	"./assets/images/11/bg/small/01.jpg": 5807,
	"./assets/images/12/bg/big/01.jpg": 2257,
	"./assets/images/12/bg/small/01.jpg": 8367,
	"./assets/images/2/bg/big/01.jpg": 9205,
	"./assets/images/2/bg/small/01.jpg": 4798,
	"./assets/images/3/bg/big/01.jpg": 4833,
	"./assets/images/3/bg/small/01.jpg": 5412,
	"./assets/images/4/bg/big/01.jpg": 9328,
	"./assets/images/4/bg/small/01.jpg": 7324,
	"./assets/images/5/bg/big/01.jpg": 6598,
	"./assets/images/5/bg/small/01.jpg": 2752,
	"./assets/images/6/bg/big/01.jpg": 4414,
	"./assets/images/6/bg/small/01.jpg": 1238,
	"./assets/images/7/bg/big/01.jpg": 9711,
	"./assets/images/7/bg/small/01.jpg": 3118,
	"./assets/images/general/bg/big/01.jpg": 1393,
	"./assets/images/general/bg/small/01.jpg": 2156,
	"./pages/summary/assets/challenge/catalogna-basic.jpg": 4334,
	"./pages/summary/assets/challenge/cibo-basic.jpg": 3493,
	"./pages/summary/assets/challenge/cinema-basic.jpg": 5912,
	"./pages/summary/assets/challenge/classic-easy.jpg": 8165,
	"./pages/summary/assets/challenge/conosci-italia-basic.jpg": 5713,
	"./pages/summary/assets/challenge/conosci-italia-easy.jpg": 9819,
	"./pages/summary/assets/challenge/conosci-italia-hard.jpg": 1373,
	"./pages/summary/assets/challenge/europe-basic.jpg": 7609,
	"./pages/summary/assets/challenge/food-basic.jpg": 3317,
	"./pages/summary/assets/challenge/kids-basic.jpg": 1369,
	"./pages/summary/assets/challenge/serravalle-basic.jpg": 5494,
	"./pages/summary/assets/challenge/trenino-verde-basic.jpg": 8863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2027;